import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  GETTING_VEHICLE_MAKE_AND_MODEL,
  VEHICLE_MODEL_INFO,
  GET_VEHICLE_MODEL_INFO,
  UPDATE_VEHICLE_INFO,
  UPDATE_PROPERTY_INFO,
  GETTING_PROPERTY_OCCUPANCY_INFO,
  CHECKING_RATES,
  POST_FILTER_RATES,
} from './actionTypes';

import { API_ENDPOINT, CHECK_RATES_PATH } from '../constants';

const dispatchToCorrectFinanceType = {
  Auto: UPDATE_VEHICLE_INFO,
  Home: UPDATE_PROPERTY_INFO,
};

// GET VEHICLE INFO
export const getVehicleMakeAndModelInfo = (dispatch) => {
  dispatch({ type: GETTING_VEHICLE_MAKE_AND_MODEL });
};

export const receivedVehicleMakeAndModelInfo = createAsyncThunk(
  GETTING_VEHICLE_MAKE_AND_MODEL,
  async ({ make, user }, methods) => {
    const { dispatch } = methods;
    let response;

    try {
      response = await axios.post(`${API_ENDPOINT}/vehicleMakeModels`, {
        make,
        user,
      });
    } catch (error) {
      console.error(error);
    }

    dispatch({ type: VEHICLE_MODEL_INFO, payload: response?.data });
  },
);

export const getVehicleModelInfo = (dispatch, model) => {
  dispatch({ type: GET_VEHICLE_MODEL_INFO, payload: model });
};

// Get Property Type Info
export const getPropertyAndOccupancyInfo = (dispatch) => {
  dispatch({ type: GETTING_PROPERTY_OCCUPANCY_INFO });
};

// CHECK RATES
export const checkingRates = (dispatch) => {
  dispatch({ type: CHECKING_RATES });
};

// POST FILTER RATES
export const checkUserFilterRates = createAsyncThunk(
  CHECKING_RATES,
  async ({ body, financingInfo }, methods) => {
    const { dispatch } = methods;
    let response = {};
    dispatch({ type: CHECKING_RATES });
    try {
      response = await axios.post(
        `${API_ENDPOINT}/${CHECK_RATES_PATH[financingInfo['financingType']]}/check_rates`,
        body,
      );
    } catch (error) {
      console.error(error);
    }

    dispatch({ type: POST_FILTER_RATES, payload: response?.data });
    dispatch({
      type: dispatchToCorrectFinanceType[financingInfo['financingType']],
      payload: financingInfo,
    });
  },
);

// dispatch to vehicles reducer
export const updateVehicleInfo = (dispatch, data) => {
  dispatch({ type: UPDATE_VEHICLE_INFO, payload: data });
};

// dispatch to property reducer
export const updatePropertyInfo = (dispatch, data) => {
  dispatch({ type: UPDATE_PROPERTY_INFO, payload: data });
};
